<template>
    <div class="nba-primary-content" :class="bemFacets">
        <div class="nba-primary-content--background" :style="productImage | bgImage"/>

        <div class="nba-primary-content--content-wrapper">
            <div class="nba-primary-content--title-wrapper">
                <slot name="title"/>
            </div>
            <div class="nba-primary-content--statement">
                <slot name="content"/>
            </div>

            <div class="nba-primary-content--link-list">
                <slot name="links"/>
            </div>
        </div>

        <div class="nba-primary-content--content-image">
            <slot name="image"/>
        </div>
    </div>
</template>

<script>

    import bemMixin from 'framework/mixins/bem';
    import PictureElement from 'framework/global-components/dyn/picture-element/picture-element';

    export default {
        components: { PictureElement },
        mixins: [bemMixin('nba-primary-content')],
        props: {
            productImage: {
                type: String,
                required: true,
            },
        },
    };
</script>
